import { useState, useEffect } from "react";
import { useCommonListWrap } from "../../../hooks/useCommonList/useCommonListWrap";
import { CommonListType } from "../../../hooks/useCommonList/useCommonListWrap";
import { PriceDetail } from "../../../../models/Order";
import { getListOrder, getListOrderAdmin, getListOrderPartner } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import { CommonParamsType } from "../../../hooks/useCommonList/commonHelper";
import { getListUserService } from "../../../../services/UserService";
import { getListPartnerService } from "../../../../services/PartnerService";
import Partner from "../../../../models/Partner";

export default function useListPartner(props?: CommonListType, prop?: { user?: User | null }) {
	const [listUser, setListUser] = useState<Partner[]>([]);
	const [count, setCount] = useState(0);
		const loadListOrder = async (inPage: number, inPerPage: number, name?: string, active?: string, store?: string, nameUser?: string, country?: string, destinationId?: string, noLocation?: boolean) => {
		props?.onBeginLoad?.();
		try {
			const res = await getListPartnerService(
				inPage,
				inPerPage,
				name,
				active,
				store,
				nameUser,
				country,
				destinationId,
				noLocation,
				props?.filterBanned || undefined
			);

			const data = res.data;
			setCount(res.count);
			setListUser(data);
		} catch {
			setListUser([]);
		} finally {
			props?.onEndLoad?.();
		}
	};
	const reload = () => {
		loadListOrder(
			props?.page || 1,
			props?.perPage || 50,
			props?.filterKeyword || undefined,
			props?.filterStates || "",
			props?.filterStore || "",
			props?.filterUserIdString || "",
			props?.filterCountry || undefined,
			props?.filterDestinationId || undefined,
			props?.filterNoLocation === "true",
			props?.filterBanned || undefined
		);
	};
	useEffect(() => {
		reload();
	}, [
		props?.page,
		props?.perPage,
		props?.filterKeyword,
		props?.filterStates,
		props?.filterStore,
		props?.filterUserIdString,
		props?.filterCountry,
		props?.filterDestinationId,
		props?.filterNoLocation,
		props?.filterBanned,
	]);
	return {
		listUser,
		reload,
		count,
	};
}

export const getListPartner = (prop: { user?: User | null }) => {
	const hookResult = (props: CommonListType) => useListPartner(props, prop);
	return useCommonListWrap(50, hookResult);
};
